export const TEMP_COLLECTION_UUID = '__temp__';
//# sourceMappingURL=collectionConstants.js.map